/**
 * Anmeldemaske.
 *
 * Das Feld für den zweiten Faktor erscheint erst, wenn die API es verlangt.
 * Es dauerhaft anzuzeigen wäre falsch: Bei einem Konto ohne TOTP gibt es
 * nichts einzutragen, und ein leeres Pflichtfeld verunsichert.
 */
import { useState, type ReactNode } from 'react';
import { Textfeld } from '../bausteine/Feld';
import { Meldung } from '../bausteine/Meldung';
import { ApiFehler, fehlertext } from '../lib/api';
import { useSitzung } from '../sitzung/SitzungKontext';

export function Anmelden(): ReactNode {
  const { anmelden } = useSitzung();
  const [email, setzeEmail] = useState('');
  const [passwort, setzePasswort] = useState('');
  const [code, setzeCode] = useState('');
  const [totpNoetig, setzeTotpNoetig] = useState(false);
  const [fehler, setzeFehler] = useState<string | null>(null);
  const [laeuft, setzeLaeuft] = useState(false);

  async function abschicken(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setzeLaeuft(true);
    setzeFehler(null);
    try {
      await anmelden(email, passwort, totpNoetig ? code : undefined);
    } catch (f: unknown) {
      if (f instanceof ApiFehler && f.kennung === 'totp_erforderlich') {
        // Passwort war richtig, es fehlt nur der Code. Kein Fehler, ein
        // Zwischenschritt — deshalb keine rote Meldung.
        setzeTotpNoetig(true);
        setzeFehler(null);
      } else {
        if (f instanceof ApiFehler && f.kennung === 'totp_falsch') setzeTotpNoetig(true);
        setzeFehler(fehlertext(f));
      }
    } finally {
      setzeLaeuft(false);
    }
  }

  return (
    <div className="anmeldung">
      <div>
        <div className="marke">
          <strong>GreenJar</strong>
          <span>Buchhaltung</span>
        </div>

        <form className="karte" onSubmit={(e) => void abschicken(e)}>
          <div className="karte-koerper stapel">
            {fehler ? <Meldung ton="gefahr">{fehler}</Meldung> : null}

            <Textfeld
              beschriftung="E-Mail-Adresse"
              art="email"
              wert={email}
              setzeWert={setzeEmail}
              pflicht
              gesperrt={totpNoetig}
            />

            <Textfeld
              beschriftung="Passwort"
              art="password"
              wert={passwort}
              setzeWert={setzePasswort}
              pflicht
              gesperrt={totpNoetig}
            />

            {totpNoetig ? (
              <Textfeld
                beschriftung="Code aus der Authenticator-App"
                wert={code}
                setzeWert={setzeCode}
                hinweis="Sechs Ziffern, oder ein Backup-Code."
                platzhalter="123456"
                pflicht
              />
            ) : null}

            <button type="submit" className="knopf haupt breit" disabled={laeuft}>
              {laeuft ? 'Wird geprüft …' : 'Anmelden'}
            </button>

            {totpNoetig ? (
              <button
                type="button"
                className="knopf schlicht klein"
                onClick={() => {
                  setzeTotpNoetig(false);
                  setzeCode('');
                  setzeFehler(null);
                }}
              >
                Zurück
              </button>
            ) : null}
          </div>
        </form>

        <p className="klein still" style={{ marginTop: '1rem', textAlign: 'center' }}>
          Nach acht Stunden ohne Nutzung wird die Sitzung beendet.
        </p>
      </div>
    </div>
  );
}
